import { integrationConstants as ic } from './constants'

const initialState = {
  loading: false,
  error: null,
  loginUrl: '',
  refreshToken: '',
  eventData: null,
  calendarType: '',
  calendarICSData: '',
  calendarUrl: '',
  isModalOpen: false,
  mixrId: 0,
  scope: '',
  users_external_API_connections: [],
  default_meeting: {
    google: null,
    microsoft: null,
    zoom: null
  },
  default_add_to_calendar: null,
  triggerAddToCalendar: false,
  thirdPartyconnection: {
    loading: false,
    API_connection: false,
    id_external_api_auth: 0,
    login_url: '',
    error: '',
    connection_saved: false
  },
  availableIntegrations: {
    loading: false,
    list: [],
    error: ''
  },
  activeIntegrations: {
    loading: false,
    list: [],
    error: ''
  },
  // addToCalConnections: null,
  // virtualMeetConnections: null,
  deleteIntegration: {
    loading: false,
    success: false
  },
  updateTranslationKey: {
    loading: false,
    success: false,
    error: ''
  }
}

export function integration(state = initialState, action) {
  switch (action.type) {
    case ic.POST_EVENT_TO_CAL_REQUEST: {
      return {
        ...state,
        loading: true,
        calendarType: action.calendarType,
        error: ''
      }
    }
    case ic.POST_EVENT_TO_CAL_SUCCESS: {
      return {
        ...state,
        eventData: state.calendarType === 'google' ? action.response.google_event : action.response.microsoft_event,
        refreshToken: '',
        loginUrl: '',
        loading: false
      }
    }
    case ic.POST_EVENT_TO_CAL_FAILURE:
      return {
        ...state,
        eventData: null,
        loading: false,
        error: action.error
      }
    case ic.ADD_TO_CALENDER_REQUEST:
      return {
        ...state,
        loading: true,
        calendarUrl: '',
        calendarType: action.response.calendarType
      }
    case ic.ADD_TO_CALENDER_SUCCESS: {
      const { response, calendarType, url } = action.updatedResponse
      if (calendarType === 'google') {
        return {
          ...state,
          loading: false,
          calendarUrl: url
        }
      } else {
        return {
          ...state,
          calendarICSData: response
        }
      }
    }

    case ic.ADD_TO_CALENDER_FAILURE:
      return {
        ...state,
        calendarUrl: '',
        loading: false,
        calendarICSData: '',
        error: action.error
      }

    case ic.OPEN_MODAL: {
      return {
        ...state,
        isModalOpen: true,
        mixrId: action.mixrId,
        recurrenceUpdate: action.recurrenceUpdate
      }
    }

    case ic.CLOSE_MODAL: {
      return {
        ...state,
        isModalOpen: false,
        mixrId: 0
      }
    }

    case ic.CLEAR_DATA: {
      return {
        ...initialState,
        isModalOpen: state.isModalOpen,
        mixrId: state.mixrId,
        scope: state.scope,
        users_external_API_connections: state.users_external_API_connections,
        default_meeting: state.default_meeting,
        triggerAddToCalendar: false
      }
    }
    case ic.GET_ACTIVE_DEFAULT_CONNS_REQUEST:
    case ic.GET_ALL_ACTIVE_CONNS_REQUEST: {
      return {
        ...state,
        activeIntegrations: {
          ...state.activeIntegrations,
          loading: true
        }
      }
    }

    case ic.GET_ACTIVE_DEFAULT_CONNS_SUCCESS: {
      return {
        ...state,
        activeIntegrations: {
          ...state.activeIntegrations,
          loading: false,
          list: action.isRefresh ? action.response : [...state.activeIntegrations.list, ...action.response]
        },
        triggerAddToCalendar: true
      }
    }

    case ic.GET_ALL_ACTIVE_CONNS_SUCCESS: {
      return {
        ...state,
        activeIntegrations: {
          ...state.activeIntegrations,
          loading: false,
          list: action.isRefresh ? action.response : [...state.activeIntegrations.list, ...action.response]
        }
      }
    }

    case ic.GET_ACTIVE_DEFAULT_CONNS_FAILURE:
    case ic.GET_ALL_ACTIVE_CONNS_FAILURE: {
      return {
        ...state,
        activeIntegrations: {
          ...state.activeIntegrations,
          loading: false,
          error: action.error
        }
      }
    }
    case ic.GET_EXTERNAL_API_CONNECTION_REQUEST:
      return {
        ...state,
        thirdPartyconnection: {
          ...state.thirdPartyconnection,
          loading: true,
          connection_saved: false
        }
      }

    case ic.GET_EXTERNAL_API_CONNECTION_SUCCESS:
      return {
        ...state,
        thirdPartyconnection: {
          ...state.thirdPartyconnection,
          loading: false,
          login_url: action.response.login_url,
          API_connection: action.response.API_connection,
          error: ''
        }
      }

    case ic.GET_EXTERNAL_API_CONNECTION_FAILURE:
      return {
        ...state,
        thirdPartyconnection: {
          ...state.thirdPartyconnection,
          loading: false,
          error: action.error
        }
      }
    case ic.SAVE_EXTERNAL_API_TOKEN_REQUEST:
      return {
        ...state,
        thirdPartyconnection: {
          ...state.thirdPartyconnection,
          loading: true,
          connection_saved: false
        }
      }

    case ic.SAVE_EXTERNAL_API_TOKEN_SUCCESS:
      return {
        ...state,
        thirdPartyconnection: {
          ...state.thirdPartyconnection,
          loading: false,
          API_connection: action.response.API_connection,
          id_external_api_auth: action.response.id_external_api_auth,
          error: '',
          connection_saved: true
        }
      }

    case ic.SAVE_EXTERNAL_API_TOKEN_FAILURE:
      return {
        ...state,
        thirdPartyconnection: {
          ...state.thirdPartyconnection,
          loading: false,
          error: action.error,
          connection_saved: false
        }
      }
    case ic.GET_AVAIL_ORG_CONN_REQUEST:
      return {
        ...state,
        availableIntegrations: {
          ...state.availableIntegrations,
          loading: true
        }
      }

    case ic.GET_AVAIL_ORG_CONN_SUCCESS: {
      return {
        ...state,
        availableIntegrations: {
          ...state.availableIntegrations,
          list: Object.values(action.response.external_apis).map((x) => x),
          loading: false,
          error: ''
        }
      }
    }
    case ic.GET_AVAIL_ORG_CONN_FAILURE:
      return {
        ...state,
        availableIntegrations: {
          ...state.availableIntegrations,
          loading: false,
          error: action.error
        }
      }

    case ic.SET_DEFAULT_VIRTUAL_MEET_REQUEST:
    case ic.SET_DEFAULT_ADD_TO_CALENDAR_REQUEST:
      return {
        ...state
      }

    case ic.SET_DEFAULT_VIRTUAL_MEET_SUCCESS: {
      const { default_meeting } = action?.response
      let connections = []
      if (state.activeIntegrations?.list?.length > 0) {
        connections = state.activeIntegrations.list.map((con) => {
          if (con.usage === 'virtual_meeting') {
            if (default_meeting[con.external_api]?.id_external_api_auth === con.id_external_api_auth) {
              con.is_default = 1
              return con
            } else {
              con.is_default = 0
              return con
            }
          }
          return con
        })
      }
      return {
        ...state,
        activeIntegrations: {
          ...state.activeIntegrations,
          list: connections
        }
      }
    }

    case ic.SET_DEFAULT_ADD_TO_CALENDAR_SUCCESS: {
      const { default_add_to_calendar } = action?.response
      let connections = []
      if (state.activeIntegrations?.list?.length > 0) {
        connections = state.activeIntegrations.list.map((con) => {
          if (con.usage === 'add_to_calendar') {
            const externalAPI = con.external_api === 'google' ? 'gcal' : 'microsoftcal'
            //check if respective calendar exists in default_add_to_calendar object
            if (default_add_to_calendar[externalAPI]?.id_external_api_auth === con.id_external_api_auth) {
              con.is_default = 1
              return con
            } else {
              con.is_default = 0
              return con
            }
          }
          return con
        })
      }
      return {
        ...state,
        activeIntegrations: {
          ...state.activeIntegrations,
          list: connections
        }
      }
    }

    case ic.SET_DEFAULT_VIRTUAL_MEET_FAILURE:
    case ic.SET_DEFAULT_ADD_TO_CALENDAR_FAILURE:
      return {
        ...state
      }
    case ic.REVOKE_TOKEN_REQUEST: {
      return {
        ...state,
        deleteIntegration: {
          loading: true,
          success: false
        }
      }
    }
    case ic.REVOKE_TOKEN_SUCCESS: {
      const { authToken, response } = action
      const { API_connection } = response
      if (API_connection === 'revoked') {
        let connections = []
        connections = state.activeIntegrations.list?.filter((x) => x.id_external_api_auth !== authToken)
        return {
          ...state,
          activeIntegrations: {
            ...state.activeIntegrations,
            list: connections
          },
          deleteIntegration: {
            loading: false,
            success: true
          }
        }
      }
      return {
        ...state
      }
    }
    case ic.REVOKE_TOKEN_FAILURE: {
      return {
        ...state,
        deleteIntegration: {
          loading: false,
          success: false
        }
      }
    }

    case ic.UPDATE_INTEGRATION_REQUEST: {
      return {
        ...state,
        updateTranslationKey: {
          ...state.updateTranslationKey,
          loading: true
        }
      }
    }

    case ic.UPDATE_INTEGRATION_SUCCESS: {
      const { external_api, status, usage } = action.response
      const updatedIntegrations = state.availableIntegrations.list.map((integration) => {
        if (integration.external_api === external_api && integration.usage === usage) {
          integration.is_active = status === 'activate' ? 1 : 0
        }
        return integration
      })

      return {
        ...state,
        availableIntegrations: {
          ...state.availableIntegrations,
          list: updatedIntegrations
        },
        updateTranslationKey: {
          ...state.updateTranslationKey,
          loading: false,
          success: true
        }
      }
    }
    case ic.UPDATE_INTEGRATION_FAILURE: {
      if (action.error.errorCode === 422) {
        return {
          ...state,
          updateTranslationKey: {
            ...state.updateTranslationKey,
            loading: false,
            success: false,
            error: action.error.errorMessage
          }
        }
      } else {
        return {
          ...state
        }
      }
    }

    default:
      return state
  }
}
